<ph-toolbar justify="between" nowrap>
    <ph-stack gap="tight">
        <ph-label *ngIf="showTitle">{{ section.title }}</ph-label>
        <ph-hint class="ap-header-scale" *ngIf="scaleLine">{{ scaleLine }}</ph-hint>
        <ph-hint *ngIf="showTitle && section.subtitle">{{ section.subtitle }}</ph-hint>
    </ph-stack>
    <ph-badge *ngIf="section.statusChip as chip" variant="light" [color]="chipColor(chip.tone)">{{ chip.label }}</ph-badge>
</ph-toolbar>
